import { Component, ChangeDetectorRef, ElementRef } from '@angular/core';
import { APPCONFIG } from '../../config';
import { Router }  from '@angular/router';
import { ErrorHandler } from '../../shared/services/error-handler.service';
import { SessionHandler } from '../../shared/services/session-handler.service';
import { HttpService } from '../../shared/services/http.service';
import { CommonService } from '../../shared/services/common.service';
import { LayoutService } from '../../layout/layout.service';
import { MdDialog  } from '@angular/material';
import { TranslateService } from 'ng2-translate';
import { dialogComponent } from '../../dialog/dialog.component';
declare var $: any;
@Component({
    selector: 'my-app-header',
	styles: [require('./header.component.scss')],
    template: require('./header.component.html')
})

export class AppHeaderComponent {
    AppConfig: any;
	public userDetails: any;
	dialogRef;
	isIcb:boolean = false;
	el: ElementRef;
	allAccess = false
	selectedLanguage:any;
	languageList:any;
	isFOCUser: boolean = false;
	showPasswordBanner = false;
 
	private readonly bannerDismissKey = 'ppb_dismissed_v1';
	private readonly lastDateToShowISO = '2026-02-22'; // YYYY-MM-DD


	constructor(private router: Router,public httpService : HttpService,public errorHandler : ErrorHandler, 
		public layoutService : LayoutService, public dialog: MdDialog,public sessionHandler : SessionHandler, public commonService:CommonService,
		el: ElementRef,private translate: TranslateService,){
		this.el = el;
		this.userDetails={image:''};
		this.commonService.setLoginRedirectUrl(this.router.url);
		let icbCheck = JSON.parse(this.sessionHandler.getItem('isIcb'));
		this.allAccess = JSON.parse(this.sessionHandler.getItem('allAccess'));
		this.selectedLanguage =this.sessionHandler.getItem("defaultLanguage");

		let loginDataRaw = this.sessionHandler.getItem('loginData');
  if (loginDataRaw) {
    try {
      const user = JSON.parse(loginDataRaw);
      const roles: string[] = user && user.role ? user.role : [];

      this.isFOCUser =
        roles.indexOf('FOC_ADMINISTRATOR') !== -1 ||
        roles.indexOf('FOC_APPROVER') !== -1 ||
        roles.indexOf('FOC_EMPLOYEE') !== -1 ||
        roles.indexOf('FOC_HR') !== -1;
    } catch (e) {
      this.isFOCUser = false;
    }
  }

		this.languageList = translate.getLangs();
			console.log(this.languageList)
		if(icbCheck) {
			this.isIcb = true;
		} else {
			this.isIcb = false;
		}
		try {
			if(this.sessionHandler.getItem("userDetails") != null) {
				this.userDetails = JSON.parse(this.sessionHandler.getItem("userDetails"));
				if(!this.userDetails || !this.userDetails.image) throw "Invalid user details.";
			}else {
				this.router.navigate(['/login']);
			}
		}catch(err){
			this.router.navigate(['/login']);
		}
	}
	
	setUserDetails(userDetails) {
		this.userDetails = userDetails;
	}

	
	logout() {
		this.httpService.getRequest('userOperationsApi/v1/logout')
		.subscribe(
			res => {
				this.commonService.setLoginRedirectUrl('');
				this.sessionHandler.clearAllItems();		
				this.router.navigate(['/login'],{ replaceUrl: true });
				this.httpService.onEnd();
				this.sessionHandler.saveItem("defaultLanguage",'English');
			},
			err => {
				this.commonService.setLoginRedirectUrl('');
				this.sessionHandler.clearAllItems();		
				this.router.navigate(['/login']);
				this.router.navigate(['/login'],{ replaceUrl: true });
				this.httpService.onEnd();
				this.sessionHandler.saveItem("defaultLanguage",'English');
				// this.dialogRef = this.dialog.open(dialogComponent);
				// this.dialogRef.componentInstance.msg = 'Something went wrong.Please try again.';
				// this.httpService.onEnd();
			});
	}

    ngOnInit() {
        this.AppConfig = APPCONFIG;
		this.evaluatePasswordBannerVisibility();
    }

	toggleCollapsedNav() {
		this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
	}
	
	changeLanguage() {
		this.dialogRef = this.dialog.open(languageDialog);
	}

	logoNavigate() {
		if(this.isIcb) {
			this.router.navigate(['/app/icb/dashboard']);
		} else {
			this.router.navigate(['/app/dashboard']);
		}
	}

	public languageSave() {
		console.log("AXXXXXXX")
		this.commonService.changeLanguage(this.selectedLanguage);
		this.translate.use(this.selectedLanguage);
		this.sessionHandler.saveItem("defaultLanguage",this.selectedLanguage);
		// this.dialog.closeAll();
	}

	private evaluatePasswordBannerVisibility(): void {
		const dismissed = localStorage.getItem(this.bannerDismissKey) === '1';
	 
		// Calculate if today <= 2026-02-08 (your local timezone)
		const today = new Date();
		const endDate = new Date(this.lastDateToShowISO + 'T23:59:59');
	 
		this.showPasswordBanner = !dismissed && today.getTime() <= endDate.getTime();
	  }
	 
	  dismissPasswordBanner(): void {
		localStorage.setItem(this.bannerDismissKey, '1');
		this.showPasswordBanner = false;
	  }
	 
	  onChangePasswordClick(event: Event): void {
		this.redirectForgotPassword();
	  }
	  
	redirectForgotPassword() {
		window.open(APPCONFIG.ESRP_FRONTEND_URL + "/#/forgot-password", "_blank");
	  }
}

// search open dialog
@Component({
    template: require('./language.component.html'),
    providers: [HttpService,SessionHandler]
})
export class languageDialog {
	selectedLanguage:any;
	languageList:any;

    constructor(private router: Router,private http:HttpService,
		private sessionHandler:SessionHandler,public dialog: MdDialog,private commonService : CommonService,
		private translate: TranslateService,private ref:ChangeDetectorRef)
		{
			this.languageList = translate.getLangs();
			this.selectedLanguage =this.sessionHandler.getItem("defaultLanguage");
		}

	public closeDialog(){
		this.dialog.closeAll();
	}

	public languageSave() {
		this.commonService.changeLanguage(this.selectedLanguage);
		this.translate.use(this.selectedLanguage);
		this.sessionHandler.saveItem("defaultLanguage",this.selectedLanguage);
		this.dialog.closeAll();
	}

	
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/header/header.component.ts